// Keep in sync with routes.jsx: `/:accountValue` → `path="dashboard"`
export function isAccountDashboardPath(pathname) {
  return /^\/[^/]+\/dashboard(?:\/|$)/.test(pathname)
}
